import urls from "../../global/constants/UrlConstants";
import { getCallParams, makeCall } from "../../utils/service";

export const getUsersList = async () => {
  try {
    const callParams = await getCallParams("GET");
    const response = await makeCall(urls.getUsers, callParams);
    return response;
  } catch (error: any) {
    throw error;
  }
};

export const updateUserStatus = async (obj: any) => {
  try {
    const callParams = await getCallParams("PUT", obj);
    const response = await makeCall(urls.setUserStatus, callParams);
    return response;
  } catch (error: any) {
    throw error;
  }
};

export const getUserSubscriptionDetails = async (
  id: string,
  language: string
) => {
  const url = `${urls.getUserSubscriptionDetails}/${id}/${language}`;
  try {
    const callParams = await getCallParams("GET");
    const response = await makeCall(url, callParams);
    return response;
  } catch (error: any) {
    throw error;
  }
};
